import Vue from 'vue'
Vue.filter('price', (val) => (val ? `${Math.floor(val).toLocaleString()}` : val))
